// extracted by mini-css-extract-plugin
export var b_clickable_area = "styles-module--b_clickable_area--Mlopq";
export var blink = "styles-module--blink--zI48W";